export default {"src":"/_next/static/media/backend_roadmap.e103df14.svg","height":314,"width":696,"blurWidth":0,"blurHeight":0};